import { useEffect, useCallback } from 'react'

export const useScroll = (target, callback, prefixTop = 0, deps = []) => {
    const cb = useCallback(callback, deps)
    useEffect(() => {
        const root = document.documentElement
        if(!document.querySelector(target)) return
        const handler = () => {
            const wTop = root.scrollTop
            const elements = Array.from(document.querySelectorAll(target))
            elements.forEach((el) => {
                const { y } = el.getBoundingClientRect();
                const windowPos = Math.floor(wTop + prefixTop);
                const targetPos = Math.floor(wTop + y);
                const windowViewPos = windowPos + window.innerHeight - prefixTop;
                if (targetPos <= windowViewPos && targetPos >= windowPos) {
                    cb(el)
                }
            })
            if(!elements.length) {
                window.removeEventListener('scroll', handler)
            } 
        }
        window.addEventListener('scroll', handler)
        return () => {
            window.removeEventListener('scroll', handler)
        }
    }, [target, cb, prefixTop])
}